module.exports = __webpack_public_path__ + "static/img/小鱼干.11afc6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/小鱼干.png
// module id = tGDp
// module chunks = 2